angular.module('core')
    .component("moneyInput", {
        require: {
            ngModelCtrl: "^ngModel"
        },
        bindings: {
            ngModel: '=',
            onChange: '&',
            required: '='
        },
        templateUrl: 'app/utils/money-input/money-input.html',
        controller: function ($scope, $state, $window) {
            this.currencies = [{currencyCode: "PLN"}, {currencyCode: "EUR"}, {currencyCode: "USD"}]

            this.$onInit = () => {
                if(!this.ngModel){
                    this.currency = "PLN"
                    return;
                }

                this.amount = this.ngModel.amount;
                this.currency = this.ngModel.currency;
            }

            this.setCurrency = (currency) => {
                this.currency = currency;
                this.change();
            }

            this.change = () => {
                if(this.amount == null || this.currency == null){ //== null or undefined, === undefined
                    this.ngModel = null;
                    this.onChange({value: null})
                    return
                }

                let price = {
                    amount: this.amount,
                    currency: this.currency,
                };
                this.ngModel = price;
                this.onChange({
                    value: price
                });
            }
        }
    })
